import { HYDRATE } from 'next-redux-wrapper';

import { IMailListDictionaryItem } from '@r1-frontend/api-domru/genesys-proxy/v1/mail/list';
import { IMessage } from '@r1-frontend/api-domru/genesys-proxy/v1/mail/message/list';

import { THydrateAction } from '~/src/store';

export enum EMailActionTypes {
    SET_PENDING_MESSAGES = 'MAIL/SET_PENDING_MESSAGES',
    SET_PENDING_MAIL = 'MAIL/SET_PENDING_MAIL',
    SET_UNREAD_COUNT = 'MAIL/SET_UNREAD_COUNT',
    SET_LIST = 'MAIL/SET_LIST',
    SET_MESSAGES = 'MAIL/SET_MESSAGES',
    REFRESH_MESSAGES = 'MAIL/REFRESH_MESSAGES',
}

export interface IMailState {
    refreshInterval: number,
    unreadCount: number | undefined,
    isError: boolean,
    isSuccess?: boolean,
    mailList: {
        isLoading: boolean,
        items?: IMailListDictionaryItem[],
    },
    messages: {
        isLoading: boolean,
        messagesInfo?: {
            subject: string,
            emlReqId: string,
            messages: IMessage[],
        },
    },
}

export const initialState: IMailState = {
    refreshInterval: 30 * 1000,
    unreadCount: undefined,

    isError: false,
    mailList: {
        isLoading: true,
        items: undefined,
    },
    messages: {
        isLoading: true,
        messagesInfo: undefined,
    },
};

export type TActions = {
    type: EMailActionTypes,
    payload: Partial<IMailState> | Record<string, unknown>,
};

const mailReducer = (state = initialState, action: TActions | THydrateAction): IMailState => {
    switch (action.type) {
        case HYDRATE:
            return {
                ...state,
                mailList: { isLoading: true },
                messages: { isLoading: true },
            };
        case EMailActionTypes.SET_PENDING_MAIL:
        case EMailActionTypes.SET_PENDING_MESSAGES:
        case EMailActionTypes.SET_UNREAD_COUNT:
        case EMailActionTypes.SET_LIST:
        case EMailActionTypes.SET_MESSAGES:
            return { ...state, ...action.payload };
        case EMailActionTypes.REFRESH_MESSAGES:
            return { ...state, messages: { ...state.messages, ...action.payload } };

        default:
            return state;
    }
};

export default mailReducer;

